import { Typography, styled } from '@mui/material';
import {
  chromeYellow,
  kiwiGreen, sanguine, spaceCadet,
} from '../../../../../../../../utils/colors';

const StyledTypography = styled(Typography)(() => ({
  width: 'max-content',
  fontSize: 10,
  lineHeight: '16px',
  fontWeight: 600,
  padding: '2px 8px',
  borderRadius: 4,
  textTransform: 'uppercase',
  '&.Ok': {
    color: kiwiGreen[800],
    backgroundColor: kiwiGreen[300],
  },
  '&.Generic': {
    color: kiwiGreen[800],
    backgroundColor: kiwiGreen[300],
  },
  '&.Pending': {
    color: chromeYellow[800],
    backgroundColor: chromeYellow[300],
  },
  '&.Denied': {
    color: sanguine[800],
    backgroundColor: sanguine[300],
  },
  '&.Cancelled': {
    color: spaceCadet[800],
    backgroundColor: spaceCadet[300],
  },

}));
export default StyledTypography;
